export const styles = {
  diceBtnRow: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 12,
  },
  diceBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    border: '1px solid var(--border-main)',
    borderRadius: 8,
    background: 'var(--card-inner-bg)',
    cursor: 'pointer',
    transition: 'all 0.2s',
    padding: '4px 10px',
    fontFamily: "'Inter', sans-serif",
  },
  diceBtnText: {
    fontSize: 11,
    fontWeight: 600,
    color: 'var(--text-muted)',
  },
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'var(--modal-overlay)',
    backdropFilter: 'blur(8px)',
    WebkitBackdropFilter: 'blur(8px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  },
  modal: {
    background: 'var(--card-bg)',
    borderRadius: 14,
    padding: '20px 24px 24px',
    boxShadow: 'var(--shadow-modal)',
    width: '90%',
    maxWidth: 400,
  },
  modalHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 14,
  },
  modalTitle: {
    margin: 0,
    fontSize: 16,
    fontWeight: 700,
    color: 'var(--text-primary)',
  },
  modalClose: {
    background: 'none',
    border: 'none',
    fontSize: 16,
    color: 'var(--text-hint)',
    cursor: 'pointer',
    padding: '2px 6px',
    borderRadius: 6,
    fontFamily: "'Inter', sans-serif",
  },
  dotsBar: {
    height: 6,
    backgroundColor: 'var(--bar-bg)',
    borderRadius: 3,
    overflow: 'hidden',
  },
  dotsFill: {
    height: '100%',
    borderRadius: 3,
    transition: 'width 0.3s ease',
  },
  emptyState: {
    textAlign: 'center',
    padding: '30px 20px',
  },
  emptyIcon: {
    fontSize: 36,
    marginBottom: 10,
    filter: 'grayscale(0.3)',
  },
  emptyText: {
    color: 'var(--text-hint)',
    fontSize: 14,
    lineHeight: 1.5,
  },
  section: {
    marginBottom: 20,
  },
  tableWrap: {
    borderRadius: 8,
    border: '1px solid var(--border-subtle)',
    overflow: 'auto',
    WebkitOverflowScrolling: 'touch',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  th: {
    textAlign: 'left',
    padding: '8px 10px',
    fontSize: 11,
    color: 'var(--table-header-text)',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.3px',
    backgroundColor: 'var(--table-header-bg)',
    borderBottom: '1px solid var(--border-subtle)',
  },
  td: {
    padding: '7px 10px',
    fontSize: 13,
    borderBottom: '1px solid var(--border-table-row)',
    verticalAlign: 'middle',
    color: 'var(--text-body)',
  },
  diceValue: {
    fontSize: 14,
  },
  resourceTag: {
    display: 'inline-block',
    padding: '2px 8px',
    borderRadius: 20,
    fontSize: 11,
    fontWeight: 600,
    marginRight: 3,
    marginBottom: 2,
    border: '1px solid',
  },
  totalRow: {
    backgroundColor: 'var(--table-header-bg)',
  },
  resColorDot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    flexShrink: 0,
  },
  percentCell: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
  },
  percentBar: {
    flex: 1,
    height: 6,
    backgroundColor: 'var(--bar-bg)',
    borderRadius: 3,
    overflow: 'hidden',
  },
  percentFill: {
    height: '100%',
    borderRadius: 3,
    transition: 'width 0.3s ease',
  },
  percentText: {
    fontSize: 12,
    fontWeight: 700,
    fontVariantNumeric: 'tabular-nums',
    minWidth: 32,
    textAlign: 'right',
    color: 'var(--text-primary)',
  },
};
